module.exports = __webpack_public_path__ + "static/media/sort-alpha-up-alt.e725849a.svg";